import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

/** Minimal Widerruf entry — legal visibility, low emphasis. */
export default function WiderrufFootnoteLink({ style = {}, className = '' }) {
  return (
    <p
      className={['subscription-widerruf-footnote', className].filter(Boolean).join(' ')}
      style={style}
      data-cy="widerruf-footnote"
    >
      Widerruf des Abos hier:{' '}
      <Button
        as={Link}
        to="/widerruf"
        size="small"
        basic
        className="subscription-widerruf-footnote__btn"
        data-cy="widerruf-footnote-link"
      >
        Vertrag widerrufen
      </Button>
    </p>
  );
}
